import React, { useState } from "react";
import {
  useEventHosts,
  updateEventHost,
  getUsersNamePublic,
  useEventTdId,
} from "../util/db";
import {
  Spinner,
  Form,
  Button,
  Row,
  Col,
  Card,
  Alert,
  Container,
} from "react-bootstrap";
import { useEffect } from "react";

function AdminPageUpdateHost({ eventId }) {
  const {
    data: eventHosts,
    status: eventHostsStatus,
    // error: eventHostsError,
  } = useEventHosts();

  const { data: currentTdData, status: currentTdStatus } =
    useEventTdId(eventId);

  const [hostsWithNames, setHostsWithNames] = useState([]);
  const [currentHostName, setCurrentHostName] = useState("");
  const [selectedHost, setSelectedHost] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Fetch all available hosts with names
  useEffect(() => {
    if (eventHostsStatus === "success") {
      const fetchHostNames = async () => {
        const hosts = await Promise.all(
          eventHosts.map(async (host) => {
            const name = await getUsersNamePublic(host.id);
            return {
              id: host.id,
              name: name[0].name,
            };
          })
        );
        setHostsWithNames(hosts);
      };

      fetchHostNames();
    }
  }, [eventHostsStatus, eventHosts]);

  // Fetch and set current host
  useEffect(() => {
    if (
      currentTdStatus === "success" &&
      currentTdData &&
      currentTdData.length > 0
    ) {
      const currentTdId = currentTdData[0].td_id;
      setSelectedHost(currentTdId);

      // Get current host name
      const fetchCurrentHostName = async () => {
        try {
          const nameData = await getUsersNamePublic(currentTdId);
          if (nameData && nameData.length > 0) {
            setCurrentHostName(nameData[0].name);
          }
        } catch (error) {
          console.error("Failed to fetch current host name", error);
        }
      };

      fetchCurrentHostName();
    }
  }, [currentTdStatus, currentTdData]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setIsSubmitted(false);
    try {
      await updateEventHost(eventId, selectedHost);
      setIsSubmitted(true);

      // Update the current host name display
      const selectedHostData = hostsWithNames.find(
        (host) => host.id === selectedHost
      );
      if (selectedHostData) {
        setCurrentHostName(selectedHostData.name);
      }
    } catch (error) {
      console.error("Failed to update event host", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container fluid="sm">
      <Card
        style={{ borderRadius: "12px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}
        className="mb-4"
      >
        <Card.Header
          style={{
            background: "#2D083F",
            color: "white",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Card.Title className="mb-0" style={{ color: "white" }}>
            Update Event Host
          </Card.Title>
        </Card.Header>
        <Card.Body
          style={{
            background: "#FFFFFF",
            borderRadius: "0 0 12px 12px",
            padding: "1rem 1.5rem",
          }}
        >
          {/* Current Host Display */}
          {currentHostName && (
            <Alert
              variant={
                isSubmitting ? "warning" : isSubmitted ? "success" : "info"
              }
              className="mb-3"
            >
              <strong>
                {isSubmitting
                  ? "Updating Event Host..."
                  : isSubmitted
                  ? "Event Host Updated:"
                  : "Current Event Host:"}
              </strong>{" "}
              {isSubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  {currentHostName}
                </>
              ) : (
                currentHostName
              )}
            </Alert>
          )}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="eventHostSelect">
              <Row className="align-items-center">
                <Col xs={12} sm={3} md={3}>
                  <Form.Label style={{ color: "#2D083F", marginBottom: "0" }}>
                    New Event Host
                  </Form.Label>
                </Col>
                <Col xs={8} sm={6} md={6}>
                  <Form.Control
                    as="select"
                    style={{
                      color: "#2D083F",
                      height: "38px",
                      lineHeight: "1.5",
                      padding: "6px 12px",
                      fontSize: "1rem",
                    }}
                    value={selectedHost}
                    onChange={(e) => {
                      setSelectedHost(e.target.value);
                      setIsSubmitted(false);
                    }}
                    required
                  >
                    <option value="">Select a host</option>
                    {hostsWithNames.map((host) => (
                      <option key={host.id} value={host.id}>
                        {host.name}
                      </option>
                    ))}
                  </Form.Control>
                </Col>
                <Col xs={4} sm={3} md={3}>
                  <Button
                    type="submit"
                    disabled={!selectedHost || isSubmitting}
                    size="sm"
                    className="w-100"
                  >
                    {isSubmitted ? (
                      "✔"
                    ) : isSubmitting ? (
                      <Spinner animation="border" />
                    ) : (
                      "Update"
                    )}
                  </Button>
                </Col>
              </Row>
            </Form.Group>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default AdminPageUpdateHost;
